module.exports = __webpack_public_path__ + "static/media/tour-builder-logo-header.f67cca4b.png";